import React, { useContext, useEffect, useState, useCallback } from 'react';
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Button,
  Tabs,
  Tab,
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Box,
  IconButton,
  Paper,
  CardActionArea,
  Fade,
} from '@mui/material';
import {
  ThumbUp,
  Message,
  Download,
  ChevronRight,
  Check,
  Person,
  AutoFixHigh,
  KeyboardArrowDown,
} from '@mui/icons-material';
import ApiFetch from '../ApiFetch';
import { useNavigate, useParams } from 'react-router';
import ModelSampleGallery from '../generate/ModelSampleGallery';
import ModelLicenseDisplay from './ModelLicenseDisplay';
import { LoginInfo } from '../../App';
import FavoriteIconV2 from '../FavoriteIconV2';
import Header from '../Header';
import Category from '../Category';
import Footer from '../Footer';

const ModelPage = () => {
  const params = useParams()
  const modelId = params.model_id
  const modelVersionId = params.model_version_id
    const getModelInfo = async () => {
      try {
        const response = await new ApiFetch().get(
          `${ApiFetch.API_PROTOCOL}//${ApiFetch.API_HOST}/v1/model/info/${modelId}`
        );
        const json = await response.json();
        return json;
      } catch (error) {
        console.error('Error fetching model list:', error);
        return { result: false, data: [] };
      }
    };
  // ログイン情報
  const {loginInfo,setLoginInfo} = useContext(LoginInfo)
  const [activeTab, setActiveTab] = useState(0);
  const [modelName, setModelName] = useState(0);
  const [modelUserId, setModelUserId] = useState("");
  const [modelUserName, setModelUserName] = useState("");
  const [favorite, setFavorite] = useState(0);
  const [modelThumbnail, setModelThumbnail] = useState("");
  const [selectedVersion, setSelectedVersion] = useState('');
  const [modelBaseInfo, setModelBaseInfo] = useState([])
  const [versionDialogOpen, setVersionDialogOpen] = useState(false);
  const [recommendedSettings, setRecommendedSettings] = useState({});
  
  const [allVersions,setAllVersions] = useState([
    { version: 'v2.0', date: '2024-01-20', notes: '高解像度出力の品質を改善' },
    { version: 'v1.5', date: '2023-12-15', notes: 'プロンプトの応答性を向上' },
    { version: 'v1.0', date: '2023-11-01', notes: '初回リリース' },
    { version: 'v0.9', date: '2023-10-15', notes: 'ベータ版リリース' },
    { version: 'v0.8', date: '2023-09-20', notes: 'アルファ版リリース' },
    { version: 'v0.7', date: '2023-08-10', notes: '内部テスト版' },
  ]);

  const [sampleImages, setSampleImages] = useState([]);

  const userGallery = [
    { id: 1, url: '/api/placeholder/400/400', author: 'User1', likes: 245, comments: 12 },
    { id: 2, url: '/api/placeholder/400/400', author: 'User2', likes: 189, comments: 8 },
    { id: 3, url: '/api/placeholder/400/400', author: 'User3', likes: 156, comments: 5 },
    { id: 4, url: '/api/placeholder/400/400', author: 'User4', likes: 134, comments: 7 }
  ];

  useEffect(()=>{
    getModelInfo().then((r)=>{
      setAllVersions(r.data.versions)
      setSelectedVersion(r.data.versions[0]?.name)
      setModelBaseInfo(r.data.base_info)
      setRecommendedSettings(r.data.versions[0]?.recommended_settings || {})
      setModelUserId(r.data.base_info.user_id)
      setModelUserName(r.data.base_info.user_name)
      setModelName(r.data.base_info.name)
      setFavorite(r.data.base_info.favorite === 1)
      setModelThumbnail(r.data.versions[0]?.specs?.img || "")
    })
  }
  ,[])

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const VersionCardMini = ({ version, selected, onClick }) => (
    <Paper 
      elevation={selected ? 3 : 1}
      sx={{
        p: 1,
        cursor: 'pointer',
        position: 'relative',
        border: selected ? 2 : 1,
        borderColor: selected ? 'primary.main' : 'grey.300',
        bgcolor: selected ? 'primary.50' : 'background.paper',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          bgcolor: selected ? 'primary.50' : 'grey.50',
          borderColor: selected ? 'primary.main' : 'grey.400',
        }
      }}
      onClick={onClick}
    >
      {selected && (
        <Box position="absolute" top={8} right={8}>
          <Check color="primary" />
        </Box>
      )}
      <Typography variant="subtitle1" fontWeight="medium">{version.name}</Typography>
      {/*<Typography variant="body2" color="text.secondary">{version.updated}</Typography>
      <Typography variant="body2" mt={1}>{version.description}</Typography>*/}
    </Paper>
  );

  const VersionCard = ({ version, selected, onClick }) => (
    <Paper 
      elevation={selected ? 3 : 1}
      sx={{
        p: 1,
        cursor: 'pointer',
        position: 'relative',
        border: selected ? 2 : 1,
        borderColor: selected ? 'primary.main' : 'grey.300',
        bgcolor: selected ? 'primary.50' : 'background.paper',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          bgcolor: selected ? 'primary.50' : 'grey.50',
          borderColor: selected ? 'primary.main' : 'grey.400',
        }
      }}
      onClick={onClick}
    >
      {selected && (
        <Box position="absolute" top={8} right={8}>
          <Check color="primary" />
        </Box>
      )}
      <Typography variant="subtitle1" fontWeight="medium">{version.name}</Typography>
      <Typography variant="body2" color="text.secondary">{version.updated}</Typography>
      <Typography variant="body2" mt={1}>{version.description}</Typography>
    </Paper>
  );

  const [versionFiles, setVersionFiles] = useState([]);
  const [filesLoading, setFilesLoading] = useState(false);

  // バージョンのIDを取得する関数
  const getVersionIdByName = useCallback(
    (name) => {
      const v = allVersions.find(v => v.name === name);
      return v ? v.id : null;
    },
    [allVersions]
  );

  // バージョン選択時にファイルリスト取得
  useEffect(() => {
    const versionObj = allVersions.find(v => v.name === selectedVersion);
    if (!versionObj || !versionObj.specs || !versionObj.specs.downloadable) return; // downloadableがfalseなら何もしない
    const versionId = getVersionIdByName(selectedVersion);
    if (!versionId) return;
    setFilesLoading(true);
    new ApiFetch().get(`${ApiFetch.API_PROTOCOL}//${ApiFetch.API_HOST}/v1/model/getFiles/${versionId}`)
      .then(r => r.json())
      .then(json => {
        if (json.result && Array.isArray(json.files)) {
          setVersionFiles(json.files);
        } else {
          setVersionFiles([]);
        }
        setFilesLoading(false);
      })
      .catch(() => {
        setVersionFiles([]);
        setFilesLoading(false);
      });
  }, [selectedVersion, getVersionIdByName, allVersions]);

  // バージョン選択時にサンプル画像リスト取得
  useEffect(() => {
    const versionId = getVersionIdByName(selectedVersion);
    if (!versionId) {
      setSampleImages([]);
      return;
    }
    new ApiFetch().get(`${ApiFetch.API_PROTOCOL}//${ApiFetch.API_HOST}/v1/model/getSampleImages/${versionId}`)
      .then(r => r.json())
      .then(json => {
        if (json.result && Array.isArray(json.images)) {
          setSampleImages(json.images);
        } else {
          setSampleImages([]);
        }
      })
      .catch(() => {
        setSampleImages([]);
      });
  }, [selectedVersion, getVersionIdByName]);

  // ファイルダウンロード
  const handleDownload = async (file) => {
    // ダウンロード用署名付きURL取得API（仮: /v1/model/generateModelDownloadUrl）
    const res = await new ApiFetch().post(
      `${ApiFetch.API_PROTOCOL}//${ApiFetch.API_HOST}/v1/model/generateModelDownloadUrl`,
      { fileId: file.id }
    );
    const data = await res.json();
    if (data.result && data.signedUrl) {
      window.open(data.signedUrl, '_blank');
    } else {
      alert('ダウンロードURLの取得に失敗しました');
    }
  };

  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);

  // ファイルサイズを人間可読形式で表示
  const humanFileSize = (size) => {
    if (!size) return '-';
    const i = size === 0 ? 0 : Math.floor(Math.log(size) / Math.log(1024));
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    return (size / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
  };

  const navigate = useNavigate();
  return (      
    <Box sx={{ minHeight: '100vh', bgcolor: 'grey.50' }}>
      <Header />
      <Category />
      <Box sx={{ maxWidth: 'xl', mx: 'auto', p: 4 }}>
        {/* Header Section */}
        <Grid container spacing={4} mb={4}>
          {/* Thumbnail */}
          <Grid item xs={12} md={3}>
            <Box
              component="img"
              src={sampleImages.length > 0 ? sampleImages[0].thumbnail_signed_url : "/img/"+modelThumbnail}
              alt="Model thumbnail"
              sx={{
                width: '100%',
                height: 'auto',
                aspectRatio: '1/1',
                objectFit: 'cover',
                borderRadius: 2,
                boxShadow: 2
              }}
            />
          </Grid>
          
          {/* Model Info */}
          <Grid item xs={12} md={9}>
            <Card>
              <CardHeader
                title={
                  <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h4">{modelName}</Typography>
                    <Box display="flex" gap={3} mb={0}>
                      <Box display="flex" alignItems="center" gap={1}>
                        <Typography variant="h6"><FavoriteIconV2 style={{cursor:"pointer",margin:"0 20px",fontSize:"20px"}} type="model" id={modelId} favorite={favorite} dialog={() => {}} count={-1} /></Typography>
                      </Box>
                      {/*
                      <Box display="flex" alignItems="center" gap={1}>
                        <Download />
                        <Typography variant="h6">12.5k</Typography>
                      </Box>
                      <Box display="flex" alignItems="center" gap={1}>
                        <AutoFixHigh />
                        <Typography variant="h6">45.2k</Typography>
                      </Box>
                      */}
                      <Box display="flex" alignItems="center" gap={1}>
                        <Person />
                        <Typography variant="h6" className='grey' style={{cursor: "pointer"}} onClick={() => {navigate(`/user/${modelUserId}`)}}>@{modelUserName}</Typography>
                      </Box>
                    </Box>
                  </Box>
                }
                subheader={"最終更新: "+modelBaseInfo.update_datetime}
              />
              <CardContent>
                {/* Versions Section */}
                <Box>
                  <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography variant="h6">バージョン</Typography>
                    <Button
                      endIcon={<ChevronRight />}
                      onClick={() => setVersionDialogOpen(true)}
                    >
                      すべて見る
                    </Button>
                  </Box>
                  
                  <Grid container spacing={2}>
                    {allVersions.slice(0, 3).map((version) => (
                      <Grid item xs={12} md={4} key={version.id}>
                        <VersionCardMini
                          version={version}
                          selected={selectedVersion === version.name}
                          onClick={() => setSelectedVersion(version.name)}
                        />
                      </Grid>
                    ))}
                  </Grid>
                </Box>

                {/* ▼▼▼ ここにファイルリスト表示を追加 ▼▼▼ */}
                {(allVersions.find(v => v.name === selectedVersion)?.specs?.downloadable) && (
                  <Box mt={4}>
                    <Typography variant="h6" gutterBottom>バージョン内のファイル一覧</Typography>
                    {filesLoading ? (
                      <Typography>読み込み中...</Typography>
                    ) : versionFiles.length === 0 ? (
                      <Typography color="text.secondary">このバージョンにはファイルがありません。</Typography>
                    ) : (
                      <Box component="ul" sx={{ pl: 2 }}>
                        {versionFiles.map(file => (
                          <Box component="li" key={file.id} sx={{ mb: 1, display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Typography sx={{ minWidth: 180 }}>{file.file_name}</Typography>
                            <Typography sx={{ minWidth: 80 }} color="text.secondary">{file.file_type || '-'}</Typography>
                            <Typography sx={{ minWidth: 80 }} color="text.secondary">{humanFileSize(file.file_size)}</Typography>
                            <Button
                              variant="outlined"
                              size="small"
                              startIcon={<Download />}
                              onClick={() => handleDownload(file)}
                              disabled={file.upload_status !== 1}
                            >
                              ダウンロード
                            </Button>
                            {file.upload_status !== 1 && (
                              <Typography color="warning.main" sx={{ ml: 1, fontSize: 12 }}>未アップロード</Typography>
                            )}
                          </Box>
                        ))}
                      </Box>
                    )}
                  </Box>
                )}
                {/* ▲▲▲ ファイルリストここまで ▲▲▲ */}
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        {/* Tabs Section */}
        <Box sx={{ width: '100%' }}>
          <Tabs
            value={activeTab}
            onChange={handleTabChange}
            sx={{ borderBottom: 1, borderColor: 'divider' }}
          >
            <Tab label="説明" />
            <Tab label="サンプル画像" />
            <Tab label="推奨設定" />
            <Tab label="ユーザーギャラリー" />
            <Tab label="利用許諾範囲" />
          </Tabs>

          {/* 説明タブ */}
          <TabPanel value={activeTab} index={0}>
            <Card sx={{ maxWidth: 'lg', mx: 'auto' }}>
              <CardContent sx={{ p: 4 }}>
                {/* モデルの説明 改行を有効に */}
                <Typography color="text.secondary" whiteSpace="pre-line">
                  {modelBaseInfo.description || 'このモデルの説明がここに入ります。'}
                </Typography>
              </CardContent>
            </Card>
          </TabPanel>

          {/* Sample Images Tab */}
          <TabPanel value={activeTab} index={1}>
            <Grid container spacing={3}>
              {sampleImages.map(image => (
                <Grid item xs={12} sm={6} md={3} key={image.id}>
                  <Card>
                    <CardActionArea onClick={() => { setPreviewImage(image); setPreviewOpen(true); }}>
                      <Box
                        component="img"
                        src={image.thumbnail_signed_url}
                        alt={image.prompt}
                        sx={{
                          width: '100%',
                          height: 420, // 縦長に変更
                          aspectRatio: '9/16', // 縦長比率を追加
                          objectFit: 'contain',
                          background: '#f5f5f5',
                          borderRadius: 2
                        }}
                      />
                      <CardContent>
                        <Typography variant="body2" color="text.secondary">
                          {image.prompt}
                        </Typography>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              ))}
            </Grid>
            {/* プレビューダイアログ */}
            <Dialog open={previewOpen} onClose={() => setPreviewOpen(false)} maxWidth="md" fullWidth>
              <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                サンプル画像プレビュー
                <Button onClick={() => setPreviewOpen(false)} color="inherit" size="small" sx={{ minWidth: 0, ml: 2 }}>
                  閉じる
                </Button>
              </DialogTitle>
              <DialogContent sx={{ textAlign: 'center' }}>
                {previewImage && (
                  <Box
                    component="img"
                    src={previewImage.preview_signed_url}
                    alt={previewImage.prompt}
                    sx={{
                      maxWidth: '100%',
                      maxHeight: '70vh',
                      objectFit: 'contain',
                      background: '#f5f5f5',
                      borderRadius: 2,
                      mb: 2
                    }}
                  />
                )}
                <Typography variant="body1" color="text.secondary">
                  {previewImage && previewImage.prompt}
                </Typography>
              </DialogContent>
            </Dialog>
          </TabPanel>

          {/* Settings Tab */}
          <TabPanel value={activeTab} index={2}>
            <Card sx={{ maxWidth: 'lg', mx: 'auto' }}>
              <CardContent sx={{ p: 4 }}>
                <Grid container spacing={4}>
                  {Object.entries(recommendedSettings).filter(([k,v]) => v.length > 0).map(([key, value]) => (
                    <Grid item xs={12} sm={6} key={key}>
                      <Typography variant="h6" sx={{ mb: 1 }}>
                        {key.replace(/([A-Z])/g, ' $1').trim()}:
                      </Typography>
                      <Typography color="text.secondary">{value}</Typography>
                    </Grid>
                  ))}
                </Grid>
              </CardContent>
            </Card>
          </TabPanel>

          {/* Gallery Tab */}
          <TabPanel value={activeTab} index={3}>
            <Grid container spacing={3}>
              <ModelSampleGallery modelId={modelId} />
              {false && userGallery.map(image => (
                <Grid item xs={12} sm={6} md={3} key={image.id}>
                  <Card>
                    <Box
                      component="img"
                      src={image.url}
                      alt={`User generated image by ${image.author}`}
                      sx={{
                        width: '100%',
                        height: 256,
                        objectFit: 'cover'
                      }}
                    />
                    <CardContent>
                      <Typography variant="subtitle1" gutterBottom>
                        {image.author}
                      </Typography>
                      <Box display="flex" justifyContent="space-between" color="text.secondary">
                        <Box display="flex" alignItems="center" gap={0.5}>
                          <ThumbUp fontSize="small" />
                          <Typography>{image.likes}</Typography>
                        </Box>
                        <Box display="flex" alignItems="center" gap={0.5}>
                          <Message fontSize="small" />
                          <Typography>{image.comments}</Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>
          </TabPanel>

          {/* 利用許諾範囲タブ */}
          <TabPanel value={activeTab} index={4}>
            <Grid container spacing={3}>
              <ModelLicenseDisplay
                license={modelBaseInfo.license}
                usage_permission_generate={modelBaseInfo.usage_permission_generate}
                usage_permission_online_training={modelBaseInfo.usage_permission_online_training}
                usage_permission_no_credit={modelBaseInfo.usage_permission_no_credit}
                usage_permission_derivative={modelBaseInfo.usage_permission_derivative}
                usage_permission_derivative_license={modelBaseInfo.usage_permission_derivative_license}
                usage_permission_redistribute={modelBaseInfo.usage_permission_redistribute}
                commercial_license_no_rights={modelBaseInfo.commercial_license_no_rights}
                commercial_license_service={modelBaseInfo.commercial_license_service}
                commercial_license_derivative={modelBaseInfo.commercial_license_derivative}
              />
            </Grid>
          </TabPanel>
        </Box>

        {/* Version History Dialog */}
        <Dialog
          open={versionDialogOpen}
          onClose={() => setVersionDialogOpen(false)}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>全バージョン履歴</DialogTitle>
          <DialogContent>
            <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
              {allVersions.map((version) => (
                <VersionCard
                  key={version.name}
                  version={version}
                  selected={selectedVersion === version.name}
                  onClick={() => {
                    setSelectedVersion(version.name);
                    setVersionDialogOpen(false);
                  }}
                />
              ))}
            </Box>
          </DialogContent>
        </Dialog>

        {/* Detailed Information Section */}
        <Box mt={6}>
          {false && <Typography variant="h4" gutterBottom>モデルの詳細情報</Typography>}
          {false && <Card sx={{ p: 3 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
              {[
                {
                  title: '特徴',
                  content: 'このモデルの主な特徴や強みについての詳細な説明がここに入ります。特定のスタイルやジャンルにおける性能、生成される画像の特徴などを説明します。'
                },
                {
                  title: 'トレーニング',
                  content: 'モデルのトレーニング方法、使用されたデータセット、トレーニング期間などの技術的な情報を提供します。'
                },
                {
                  title: '使用方法とヒント',
                  content: 'モデルを効果的に使用するためのヒント、推奨されるプロンプトの書き方、避けるべき点などの実践的なアドバイスを提供します。'
                },
                {
                  title: 'ライセンス',
                  content: 'モデルの使用ライセンス、商用利用の可否、クレジット表記の要件などについての情報を記載します。'
                }
              ].map((section, index) => (
                <Box key={section.title} sx={{ pb: 3, borderBottom: index < 3 ? 1 : 0, borderColor: 'divider' }}>
                  <Typography variant="h5" gutterBottom>{section.title}</Typography>
                  <Typography color="text.secondary">{section.content}</Typography>
                </Box>
              ))}
            </Box>
          </Card>}
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};

// TabPanel component for tab content
const TabPanel = ({ children, value, index }) => (
  <Fade in={value === index}>
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      sx={{ mt: 3 }}
    >
      {value === index && children}
    </Box>
  </Fade>
);

export default ModelPage;

// 編集用取得
export async function fetchModelInfoEdit(modelId) {
  return await new ApiFetch().get(`/v1/model/info/${modelId}?forEdit=1`).then(r => r.json());
}
// 公開用取得
export async function fetchModelInfoPublic(modelId) {
  return await new ApiFetch().get(`/v1/model/info/${modelId}`).then(r => r.json());
}